let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("inGUf")).then(() => parcelRequire('6PHXJ'));